import { Dialog as BaseDialog } from '@base-ui/react/dialog';
import type { ReactNode } from 'react';

import { Icon } from '../Icon';
import styles from './Drawer.module.css';

export type DrawerLayout = 'left' | 'right' | 'top' | 'bottom';

export interface DrawerProps {
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
  /** 标题与关闭按钮之间的补充内容，例如保存状态。 */
  headerExtra?: ReactNode;
  /** 紧随标题的补充内容，与标题保持独立语义。 */
  titleSupplement?: ReactNode;
  layout?: DrawerLayout;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  title: string;
  /** 左右抽屉的场景化宽度；未传时使用组件默认宽度。 */
  width?: number | string;
}

export function Drawer({ children, className, footer, headerExtra, layout = 'right', onOpenChange, open, title, titleSupplement, width }: DrawerProps) {
  const popupStyle = width === undefined || (layout !== 'left' && layout !== 'right') ? undefined : { width: typeof width === 'number' ? `${width}px` : width };
  const closeControl = <BaseDialog.Close aria-label={`关闭${title}`} className={styles.close} data-icon="close">
    <Icon name="close" size="xs" />
  </BaseDialog.Close>;
  const heading = <BaseDialog.Title className={styles.title} data-has-extra={headerExtra || titleSupplement ? '' : undefined} render={<h1 />}>{title}</BaseDialog.Title>;

  return (
    <BaseDialog.Root open={open} onOpenChange={onOpenChange}>
      <BaseDialog.Portal>
        <BaseDialog.Backdrop className={styles.backdrop} />
        <BaseDialog.Popup aria-modal="true" className={[styles.popup, className].filter(Boolean).join(' ')} data-layout={layout} style={popupStyle}>
          <header className={styles.header}>
            {titleSupplement ? <div className={styles.headingContent}>{heading}{titleSupplement}</div> : heading}
            {headerExtra ? <div className={styles.headerActions}>{headerExtra}{closeControl}</div> : closeControl}
          </header>
          <div className={styles.body}>{children}</div>
          {footer ? <footer className={styles.footer}>{footer}</footer> : null}
        </BaseDialog.Popup>
      </BaseDialog.Portal>
    </BaseDialog.Root>
  );
}
